import React from 'react';
import { useTheme } from '../../theme';
import { CSSRulesFunction, ResponsiveValue } from '../../theme/types';
import { omit } from '../../utils';
import Box, { BoxProps } from '../Box';

export type Size = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type AppearanceProps =
  | {
      size: ResponsiveValue<Size>;
    }
  | { gridColumn: ResponsiveValue<string> };

export type ColProps = Omit<
  BoxProps,
  'minWidth' | 'width' | 'flexBasis' | 'gridColumn'
> &
  AppearanceProps;

const colStyle: CSSRulesFunction<AppearanceProps> = (theme, props) => {
  // 'gridColumn' prop takes precedence over 'size' prop
  const gridColumn =
    'gridColumn' in props
      ? theme.responsiveStyle(props.gridColumn, ['gridColumn'])
      : theme.responsive(props.size, sizeValue => ({
          gridColumn: `auto / span ${sizeValue}`,
        }));

  return [gridColumn];
};

const Col: React.FC<ColProps> = React.memo(function Col(props) {
  const rest = omit(props, ['size' as keyof ColProps]);
  const { theme } = useTheme();

  return <Box css={colStyle(theme, props)} {...rest} />;
});

export default Col;
